module.exports = __webpack_public_path__ + "img/zombie_small.a143e0f0.png";